import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

class ImportProductPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.importProduct = this.importProduct.bind(this);
        this.state = {
            categories: []
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('importProduct', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            if (data.error) {

            } else if (data.successful) {
                this.props[0].history.push(`/products`);

            }
        });

        this.props.socketIOClient.on('categories', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                categories: data
            });
        });


        this.props.socketIOClient.emit('categories', {});





    }

    importProduct() {
        this.props.handleLoader(true);

        this.props.socketIOClient.emit("importProduct", this.state);
    }


    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("categories");
        this.props.socketIOClient.removeAllListeners("addCategory");
    }

    render() {

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel panel-6">
                    <div className="panel-title">
                        <h1>{this.props.translate('Import product')}</h1>
                        <h6>{this.props.translate('Fill fields to import product')}</h6>

                    </div>

                    <div>



                        <div className="input-wrap">
                            <label>{this.props.translate('Category')}</label>
                            <select value={this.state.category} onChange={(e) => { this.setState({ category: e.target.value }) }}>
                                <option>- - NONE - -</option>
                                {
                                    this.state.categories.map((category) => {
                                        return (
                                            <option value={category._id}>{category.name}</option>
                                        )
                                    }
                                    )}
                            </select>
                        </div>


                        <div className="input-wrap">
                            <label>{this.props.translate('URL')}</label>
                            <input type="text" value={this.state.url} onChange={(e) => { this.setState({ url: e.target.value }) }} />
                        </div>


                        <div className="input-wrap">
                            <button className="button" onClick={this.importProduct}>{this.props.translate('Import')}</button>
                        </div>


                    </div>
                </div>


            </div>
        );
    }
}

export default PageWithLayout(ImportProductPage);


// WEBPACK FOOTER //
// ./src/views/importProductPage.js